import Logo from '@assets/qontact-logo-orange.png';
import type { ColaboratorInfo } from '@models/Colaborators';
import type { ShiftRecipeWithUserIDs } from '@models/QontactPoint';
import { formatShiftDays, formatShiftHours } from '@utils/ShiftRecipeFormat';

interface QontactPointShiftsPdfInput {
    qontactPointName: string;
    recipes: ShiftRecipeWithUserIDs[];
    collaborators: ColaboratorInfo[];
}

/** "Exportar turnos": one row per shift with days, hours and people */
export const downloadQontactPointShiftsPdf = async ({ qontactPointName, recipes, collaborators }: QontactPointShiftsPdfInput) => {
    const [{ default: jsPDF }, { default: autoTable }] = await Promise.all([
        import('jspdf'),
        import('jspdf-autotable'),
    ]);
    const nameByID = new Map(collaborators.map((collaborator) => [collaborator.id, collaborator.name]));

    const doc = new jsPDF();
    doc.setFontSize(12);
    doc.text(`${'Turnos de'.localized()} ${qontactPointName}`, 15, 20);

    const pageWidth = doc.internal.pageSize.width;
    const logoWidth = pageWidth * 0.2;
    doc.addImage(Logo, 'PNG', pageWidth - logoWidth - 15, 14, logoWidth, logoWidth / (483 / 90));

    if (recipes.length === 0) {
        doc.text('No hay turnos configurados.'.localized(), 15, 35);
    } else {
        autoTable(doc, {
            startY: 30,
            head: [['Turno', 'Días', 'Horario', 'Personas esperadas', 'Asignadas por nombre'].map((title) => title.localized())],
            body: recipes.map((recipe) => {
                const assigned = Array.from(new Set(recipe.userIDs ?? []));
                return [
                    recipe.name,
                    formatShiftDays(recipe),
                    formatShiftHours(recipe),
                    String(recipe.expected ?? 0),
                    assigned.length > 0
                        ? assigned.map((id) => nameByID.get(id) ?? 'Colaborador'.localized()).join(', ')
                        : '—',
                ];
            }),
            theme: 'grid',
            styles: { fontSize: 8 },
            headStyles: { fillColor: [41, 128, 185], textColor: 255 },
        });
    }

    doc.save(`turnos_${qontactPointName}.pdf`);
};
